<template>
  <ConfirmDialog></ConfirmDialog>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Trabajadores</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">Listado</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <Toast />
    <div class="flex align-items-start flex-column lg:justify-content-between lg:flex-row">
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Trabajadores
          <Badge size="xlarge" severity="success"> {{ totalRegistros }}</Badge>
        </div>
      </div>
      <div class="flex mt-3 lg:mt-0">
        <Button
          v-if="'Trabajador Crear' in auth.user.permissions"
          label="NUEVO"
          v-tooltip.top="'Nuevo Trabajador'"
          icon="pi pi-plus"
          class="p-button-outlined mr-2 p-button-lg"
          @click="openNuevo"
        />
      </div>
    </div>
    <div class="mt-4">
      <DataTable
        ref="dtTrabajadores"
        :value="trabajadores"
        :loading="cargando"
        dataKey="id"
        :paginator="true"
        :rows="10"
        :rowHover="true"
        :filters="buscar"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[5, 10, 25]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Trabajadores"
        responsiveLayout="scroll"
        selectionMode="single"
      >
        <template #header>
          <div class="flex flex-column md:flex-row md:justify-content-end md:align-items-end">
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText v-model="buscar['global'].value" placeholder="Buscar Trabajador..." />
            </span>
          </div>
        </template>

        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span class="flex align-items-center justify-content-center p-invalid">No existen Registros!</span>
        </template>
        
        <Column header="#">
          <template #body="slotProps">
            {{ 1 + slotProps.index }}
          </template>
        </Column>

        <Column field="nombre_completo" header="NOMBRE" :sortable="true"></Column>
        <Column field="carnet_identidad" header="CI" :sortable="true"></Column>
        <Column field="celular" header="CELULAR"></Column>
        <Column field="direccion" header="DIRECCIÓN"></Column>
        <Column field="fecha_nacimiento" header="FECHA NACIMIENTO">
          <template #body="{ data }">
            {{ formatDate(data.fecha_nacimiento) }}
          </template>
        </Column>
        <Column field="fecha_contratacion" header="FECHA CONTRATACION">
          <template #body="{ data }">
            {{ formatDate(data.fecha_contratacion) }}
          </template>
        </Column>
        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span :class="'product-badge ' + (data.estado ? 'status-instock' : 'status-outofstock')">
              {{ data.estado ? 'Activo' : 'Inactivo' }}
            </span>
          </template>
        </Column>

        <Column header="ACCIONES">
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised"
              v-tooltip.top="'Ver Acciones'"
              icon="pi pi-ellipsis-v"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            >
            </Menu>
          </template>
        </Column>
      </DataTable>
    </div>
    <TrabajadorCreate
      :show="trabajadorDialog"
      :trabajador="trabajador"
      @closeModal="ocultarDialog"
      @actualizarListado="cargarTrabajadores"
    />
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import { useAuth } from "@/stores";
import TrabajadorService from "@/service/TrabajadorService";
import TrabajadorCreate from "./TrabajadorCreate.vue";

export default {
  components: {
    TrabajadorCreate
  },
  data() {
    return {
      trabajadores: [],
      cargando: true,
      buscar: {},
      totalRegistros: 0,
      trabajadorDialog: false,
      trabajador: {},
    };
  },
  trabajadorService: null,
  auth: null,
  created() {
    this.auth = useAuth();
    this.trabajadorService = new TrabajadorService();
    this.initBuscar();
  },
  mounted() {
    this.cargarTrabajadores();
  },
  methods: {
    acciones(datos) {
      let permisosUsuarioAuth = this.auth.user.permissions;
      return [
        {
          label: "Editar",
          disabled: "Trabajador Editar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-pencil",
          command: () => {
            this.editarTrabajador(datos);
          },
        },
        {
          label: "Eliminar",
          disabled: "Trabajador Eliminar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-trash",
          command: () => {
            this.deleteTrabajador(datos.id);
          },
        }
      ];
    },
    cargarTrabajadores() {
      this.cargando = true;
      this.trabajadorService.getTrabajadores().then((res) => {
        this.trabajadores = res.trabajadores;
        this.totalRegistros = this.trabajadores.length;
        this.cargando = false;
      }).catch(() => {
        this.cargando = false;
      });
    },
    openNuevo() {
      this.trabajador = {
        estado: { label: "Activo", value: 1 },
      };
      this.trabajadorDialog = true;
    },
    editarTrabajador(datos) {
      this.trabajador = { ...datos };
      this.trabajadorDialog = true;
    },
    ocultarDialog() {
      this.trabajadorDialog = false;
      this.trabajador = {};
    },
    deleteTrabajador(id) {
      this.$confirm.require({
        message: "¿Está seguro que desea eliminar este Trabajador?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si, deseo eliminar",
        rejectLabel: "No, cancelar",
        accept: () => {
          this.trabajadorService
            .deleteTrabajador(id)
            .then((response) => {
              if (response.status == 200) {
                this.$toast.add({
                  severity: "success",
                  summary: "Éxito",
                  detail: response.mensaje,
                  life: 3000,
                });
                this.cargarTrabajadores();
              }
            });
        },
      });
    },
    initBuscar() {
      this.buscar = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    formatDate(value) {
      if (!value) return "";
      const date = new Date(value);
      if (isNaN(date)) return value;
      
      return date.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>
